import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Box = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.background};
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  border-top: 1px solid ${({ theme }) => theme.palette.primary.border};
  margin-top: 10px;
  padding: 20px 15px 0;
`;

export const Title = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  margin-bottom: 15px;
`;

export const TotalTitle = styled(Typography.Header)`
  margin-bottom: 0;
`;

export const TotalValue = styled(Typography.Header)`
  text-align: right;
`;

export const Chips = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
`;

export const PackageBox = styled.div`
  padding: 20px;
  border-radius: 7px;
  background: linear-gradient(320deg, #decfa7 0%, #ede6d2 100%);
  margin-bottom: 20px;
`;

export const PackageName = styled(Typography.Header)`
  margin-bottom: 20px;
`;

export const PackageAdv = styled(Typography.Body)`
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin-top: 15px;
`;

export const TotalTable = styled.div`
  padding: 20px 15px;
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  margin-bottom: 20px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const Value = styled(Typography.Body)`
  text-align: right;
`;

export const PayButton = styled(Button)`
  width: calc(100% - 30px);
  margin: 25px auto 15px;
`;

export const Details = styled(Typography.Body)`
  padding: 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
`;

export const PayButtonBox = styled.div`
  margin-top: auto;
  padding: 15px;
`;
